// Motion tokens shared by GSAP and framer-motion usage.
export const DUR = { fast: 0.4, base: 0.8, slow: 1.2 };
export const EASE = { out: 'power3.out', expo: 'expo.out', inOut: 'power2.inOut' };
export const EASE_CSS = [0.16, 1, 0.3, 1];
export const STAGGER = 0.06;

export function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function isDesktop() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(min-width: 1024px)').matches;
}
